<template>

    <div class=" bg-den_bg_lighter rounded-lg">
        
        <div class="mb-1 rounded-lg">
            <figure class="image is-flex card-image">
                <video
                    v-if=ReviewableIsVideo()
                    controls
                    loop
                    preload="none"
                    v-bind:poster=GetThmURL()
                    v-bind:src=GetUploadURL()
                >
                </video>
                <img v-else-if=ShowOriginalImage() v-bind:src=GetUploadURL()>
                <img v-else v-bind:src=GetThmURL()>
            </figure>
        </div>

        <div id="rev-card-buttons" class="buttons is-pulled-right">

            <!-- dont really need filter by shared -->
            <!-- <a v-if="IsShared"
                @click="QueryShared()"
                id="shared-link" 
                class="button is-primary is-inverted"
            >
                <b-icon
                    icon="send"
                    size="is-small">
                </b-icon>
            </a> -->


            <!-- is_user_admin comes from mixin -->
            <!-- edit button -->
            <a v-if="is_user_admin"
                @click="RevAdmin()"
                class="button is-primary"
                :href="'/admin/dencore/reviewable/' + reviewable.id + /change/"
            >
                <b-icon
                    icon="pencil"
                    size="is-small">
                </b-icon>
            </a>

            <!-- publish button -->
            <a @click="TogglePublished()"
                class="button is-primary"
                v-bind:class="{ 'is-inverted': reviewable.published }"
            >
                <b-icon
                    icon="flag"
                    size="is-small">
                </b-icon>
            </a>
            
            <!-- share -->
            <a @click="ToggleSelectReviewable()"
                class="button is-primary"
                v-bind:class="{ den_selected: selected, 'is-inverted': IsShared }"
            >
                <b-icon
                    icon="send"
                    size="is-small">
                </b-icon>
            </a>

            <!-- download button -->
            <b-button @click="Download()"
                class="button is-primary"
                :loading=is_downloading
            >
                <b-icon
                    icon="download"
                    size="is-small">
                </b-icon>
            </b-button>

        </div>


        <div class="card-content">
                
            <router-link class="title" :to="{ name: 'single', params: {id: reviewable.id } }">
                {{ reviewable.name }}
            </router-link>

            <div class="content">

                <router-link :to="{ name: 'project', params: {project: reviewable.project } }">
                    {{ reviewable.project }}
                </router-link>

                <router-link v-if="NoneValues(reviewable.shot.toLowerCase())"
                    :to="{
                        name: 'shot',
                        params: {
                            shot: reviewable.shot,
                            project: reviewable.project
                        }
                    }"
                >
                    / Shot {{ reviewable.shot }}
                </router-link>

                <span v-if="NoneValues(reviewable.version.toLowerCase())">
                    / v{{ reviewable.version }}
                </span>

                <!-- notes -->
                <div v-if="reviewable.notes" class="is-italic">
                    {{ reviewable.notes }}
                </div>
            </div>
        </div>

        <b-progress v-if="is_downloading" :value=download_percentage show-value format="percent" type="is-primary"></b-progress>

        <footer class="card-footer">
            <div class="card-footer-item">
                
                <a class="filter-link is-size-7" @click="UpdateQuery('user', reviewable.user)">
                    <span>{{ reviewable.user }}</span>
                    <b-icon
                        icon="filter-outline"
                        size="is-small">
                    </b-icon>
                </a>
            </div>

            <div v-if="reviewable.tags.length!=0"
                class="card-footer-item is-size-7"
            >
                <b-icon
                    icon="tag-outline"
                    size="is-small">
                </b-icon>

                <div
                    v-for="tag in reviewable.tags"
                    v-bind:key="tag.id"
                >
                    <a class="filter-link is-size-7" @click="UpdateQuery('tags__name', tag.name)">
                        <span>{{ tag.name }}</span>
                    </a>
                </div>
            </div>

            <div class="card-footer-item is-size-7">
                {{ reviewable.date_created | formatDate }}
            </div>
            
            <div v-if="dependencies_scenes" v-for="scene in dependencies_scenes">
                <router-link :to="{ name: 'scene', params: {id: scene.id} }">
                    <b-tag type="is-primary" class="dep-tag">{{ scene.name }}</b-tag>
                </router-link>
            </div>

            <div v-if="dependencies_reviewables" v-for="rev in dependencies_reviewables">
                <router-link :to="{ name: 'single', params: {id: rev.id} }">
                    <b-tag class="dep-tag">{{ rev.name }}</b-tag>
                </router-link>
            </div>
        </footer>

    </div>
</template>


<script>

    import axios from 'axios'
    import moment from 'moment'
    
    // import global event bus which can be used over multiple routes/components
    import { eventBus } from '../main';
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    // for is_user_admin
    import { GetUserAdmin } from '../mixins/users'
    import {ShareIcon} from '../assets/svg/share.vue'
    import {CloudIcon} from '../assets/svg/cdl.vue'
    export default {
        components: { ShareIcon, CloudIcon },
        mixins: [GetAxiosAuthConfig, GetUserAdmin],
        data() {
            return {
                selected: false,
                query_user: this.$route.query.user,
                query_shared: this.$route.query.shared,
                is_downloading: false,
                download_percentage: 0,
                dependencies_scenes: false,
                dependencies_reviewables: false,
            }
        },
        // expect an object as a prop
        props: {
            reviewable : Object,
        },
        computed: {
            IsShared: function() {
                let shared = false

                if (this.reviewable.shared_count > 0) {
                    shared = true
                }
                return shared
            },
        },
        methods: {
            NoneValues(value) {
                // covers a field with various false/none/null, need to be consistant on entry instead
                let nones = ['', 'null', 'none', 'false']
                if (nones.includes(value)) {
                    return false
                }
                else{
                    return true
                }
            },
            forceFileDownload(response) {
                // get filename from url
                let file_url = response.config.url.split("?")[0]
                let filename = file_url.split('\\').pop().split('/').pop();

                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', filename) //or any other extension
                document.body.appendChild(link)
                link.click()
            },
            Download() {
                this.is_downloading = true

                axios({
                    method: 'get',
                    url: this.reviewable.file_upload,
                    responseType: 'arraybuffer',
                    onDownloadProgress: ( progressEvent ) => {
                        let percentage = Math.round(( progressEvent.loaded / (progressEvent.total) ) * 100 )
                        // max 95, then set 100 when request is done
                        this.download_percentage = Math.min(Math.max(parseInt(percentage), 0), 95)
                    }
                })
                .then(response => {
                    // this only runs when its fully downloaded

                    // set as 100 when done
                    this.download_percentage = 100

                    // Finished loading
                    this.is_downloading = false
                    // reset
                    this.download_percentage = 0

                    this.forceFileDownload(response)
                })
                .catch(() => console.error('error occured'))
            },
            HasFileUpload() {               
                if (this.reviewable.file_upload == null) {
                    // old style
                    return false
                }
                else {
                    return true
                }
            },
            GetUploadURL() {
                if (this.HasFileUpload()) {
                    // new style
                    return this.reviewable.file_upload
                }
                else {
                    // old style
                    return this.reviewable.url
                }
            },
            GetThmURL() {
                if (this.HasFileUpload()) {
                    // new style
                    return this.reviewable.thumbnail
                }
                else {
                    // old style
                    return this.reviewable.url + '.thm'
                }
            },
            ShowOriginalImage() {
                // to show a gif, but could work for other cases, so I made it a generic function name

                // cover old style url param
                if (this.HasFileUpload()) {
                    var upload = this.reviewable.file_upload
                }
                else {
                    // check url instead
                    var upload = this.reviewable.url
                }

                // check extension
                // TODO this is so basic
                let use_orig_extension = ['gif']

                // links to aws now are presigned so there is a lot of text after the '?'
                // so split there to get the actual file path
                let file_url = upload.split("?")[0]

                // if it is a gif, load the original image now the thumb
                if (use_orig_extension.includes(file_url.split(".").pop().toLowerCase())) {
                    return true
                }
                else {
                    return false
                }
            },
            ReviewableIsVideo() {
                // cover old style url param
                if (this.HasFileUpload()) {
                    var upload = this.reviewable.file_upload
                }
                else {
                    // check url instead
                    var upload = this.reviewable.url
                }

                // check extension
                // TODO this is so basic
                var video_extensions = ['mp4', 'mov', 'avi']

                // links to aws now are presigned so there is a lot of text after the '?'
                // so split there to get the actual file path
                let file_url = upload.split("?")[0]

                // if it is a gif, load the original image now the thumb
                if (video_extensions.includes(file_url.split(".").pop().toLowerCase())) {
                    return true
                }
                else {
                    return false
                }
            },
            ToggleSelectReviewable() {
                // Run function rather than emiting
                eventBus.ToggleSelectedReviewable(this.reviewable)
            },
            TogglePublished() {
                // send api command to toggle published
                let resturl = window.location.origin + '/api/reviewables/' + this.reviewable.id + '/'

                // get current state
                let original_state = this.reviewable.published

                // update vue
                this.reviewable.published = !original_state

                // create payload
                let payload = {
                    published: !original_state
                }

                // POST a new reviewableshare on den-server
                axios.patch(resturl, payload, axios_auth_config)
                    .then(response => {
                    })
                    .catch(error => console.error(error))
            },
            UpdateQuery(field, value) {
                // append router query
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        [field]: value
                    }
                })
            },
            QueryShared() {
                this.$router.push({query: {shared: 1}})
            },
            GetDependencies() {
                // instead of using the field on the reviewable, use the API endpoint
                let resturl = window.location.origin + '/api/reviewables/' + this.reviewable.id + '/dependencies/'

                axios.get(resturl, axios_auth_config)
                    .then(response => {
                        this.dependencies_scenes = response.data.scenes
                        this.dependencies_reviewables = response.data.reviewables
                    })
                    .catch(error => console.error("get next page url error", error))
            },
        },
        created() {
            // on creation start listening for events when a reviewable is selected
            // when event is called check if this rev card is in the list, and set its class to show that it is selected
            // because it can be deselected by other methods outside of this component, eg. deselected in the share picker
            eventBus.$on('reviewable_selected', (selected_reviewables) => {
                this.selected = eventBus.IsReviewableSelected(this.reviewable)
            })

            // parse as json (better to do this always for reviewables somewhere?)
            // this.dependencies = JSON.parse(this.reviewable.dependencies)
            this.GetDependencies()
        },
        filters: {
            // reformats a date using moment.js
            formatDate(value) {
                if (value) {
                    var datetimetext = moment(String(value)).format('HH:mm, D MMM YYYY')
                    var fromnow = moment(String(value)).fromNow()
                    return fromnow + ", " + datetimetext
                }
            },
        }
    }

</script>


<style scoped lang="scss">
    @import "../styles/_variables.scss";

    .card {
        border-radius: .2em; // like dailies
    }
    .card-content {
        padding: 0 0.5rem 0.5rem 0.5rem;
        font-size: 0.8rem;
    }
    .card-image {
        max-height: 84vh;
    }
    .card-footer-item {
        padding: 0.1rem;
    }
    .title {
        font-size: 1rem;
    }
    hr {
        margin: 0.5rem;
        height: 1px;
    }
    video {
        width: 100%;
    }

    /* vh is view height */
    .card img {
        max-height: 75vh;
    }

    /*  if rev has already been shared - important to override */
    .den_selected {
        background-color: $den_offwhite !important;
    }

    // gets inverted class instead (like already shared)
    // .den_rev_published {
    //     background-color: $den_offwhite;
    // }

    #rev-card-buttons {
        margin-right: 0.5rem;
        margin-bottom: 0;
    }

    .filter-link {
        padding: 0.1rem;
    }
    .dep-tag {
        margin: .2em;
    }
</style>
